import {
  HelpCircle,
  Building,
  Sparkles,
  Thermometer,
  Wifi,
  Calendar,
  PawPrint,
  ShieldAlert,
  Coffee,
  Printer,
  FileText,
  Key,
  DoorOpen,
  Phone,
  Mail,
  User,
  Users,
  Settings,
  Info,
  Folder,
  Home,
  Car,
  Lock,
  Shield,
  CreditCard,
  Bell,
  MapPin,
  Clock,
  BookOpen,
  Video,
  Monitor,
  Headphones,
  Wrench,
  KeyRound,
  Siren,
  BellRing,
  type LucideIcon,
} from "lucide-react";

// Operators set ``FAQCategory.icon`` as a free-text lucide name (admin UI hint:
// "wifi, printer, key"). We map the names we expect to tree-shakeable imports —
// importing lucide's full ``icons`` map would pull all ~1500 glyphs into the
// bundle. Unknown / unset names fall back to HelpCircle. Extend as operators
// adopt new ones.
export const ICON_MAP: Record<string, LucideIcon> = {
  building: Building,
  sparkles: Sparkles,
  thermometer: Thermometer,
  wifi: Wifi,
  calendar: Calendar,
  "paw-print": PawPrint,
  "shield-alert": ShieldAlert,
  coffee: Coffee,
  printer: Printer,
  "file-text": FileText,
  key: Key,
  "door-open": DoorOpen,
  phone: Phone,
  mail: Mail,
  user: User,
  users: Users,
  settings: Settings,
  info: Info,
  folder: Folder,
  home: Home,
  car: Car,
  lock: Lock,
  shield: Shield,
  "credit-card": CreditCard,
  bell: Bell,
  "map-pin": MapPin,
  clock: Clock,
  "book-open": BookOpen,
  video: Video,
  monitor: Monitor,
  headphones: Headphones,
  wrench: Wrench,
  "key-round": KeyRound,
  siren: Siren,
  "bell-ring": BellRing,
  "help-circle": HelpCircle,
};

/** The lucide icon for an operator-set icon name (FAQ categories, guides). */
export function faqIcon(name: string | null | undefined): LucideIcon {
  if (!name) return HelpCircle;
  return ICON_MAP[name.trim().toLowerCase()] ?? HelpCircle;
}

/** The lucide icon for a name, or `null` when the name is unknown or unset —
 *  for places that draw nothing rather than a "?" (guide step headers). */
export function knownIcon(name: string | null | undefined): LucideIcon | null {
  if (!name) return null;
  return ICON_MAP[name.trim().toLowerCase()] ?? null;
}
